import { ItemMenu } from './item-menu';

export class ItemMenuPai {
    nome: string;
    icone: string;
    items: ItemMenu[];

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}



// WEBPACK FOOTER //
// ./src/app/_models/menu/item-menu-pai.ts